export default __webpack_public_path__ + "static/media/LATINOS_US.af9d6ae3.png";